import React from 'react';
import NewInterestForm from './NewInterestForm';
// import Interest from './Interest';
import { connect } from 'react-redux';
import { removeInterest } from './actions';

const InterestList = ({ interests = [], onRemovePressed }) => {
    return (
        <div>
            <NewInterestForm />
            {interests?.length > 0 &&
                (
                    <div className="mb-3"
                        style={{ marginTop: 20, borderTop: '1px solid #e0e0e0' }}
                    >
                        <table className='table table-bordered'>
                            <thead>
                                <tr>
                                    <th>Sr. no.</th>
                                    <th>Name</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {interests.map((interest, key) => (
                                    <tr key={key}>
                                        <td>{key + 1}</td>
                                        <td>{interest.interest.interest}</td>
                                        <td>
                                            <button
                                                className="btn btn-danger btn-sm rounded-circle"
                                                style={{ margin: 0 }}
                                                onClick={() => onRemovePressed(interest.interest)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                </svg>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )
            }
            {/* <div className="container mb-3">
            {interests.map(interest => <Interest interest={interest.interest} onRemovePressed={onRemovePressed}/>)}
        </div> */}
        </div>
    )
}

const mapStateToProps = state => ({
    interests: state.interests,
});

const mapDispatchToProps = dispatch => ({
    onRemovePressed: interest => dispatch(removeInterest(interest)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InterestList);